document.addEventListener("DOMContentLoaded", function () {

  setInterval(() => {
    const countryText = document.querySelector('.ts-country__name');
    const countryFlag = document.querySelector('.ts-country__flag');
    const countryBoxNames = document.querySelectorAll('.ts-country .ts-list-item__name');
    const countryBoxFlags = document.querySelectorAll('.ts-country .ts-list-item__flag');
    if (countryText && countryText.textContent.trim() === 'Germany') {
      countryText.textContent = 'Switzerland';
    }
    if (countryFlag && countryFlag.src.includes('/de.svg')) {
      countryFlag.src = 'https://app.transtore.app/flags/ch.svg';
      countryFlag.alt = 'Switzerland';
    }
    countryBoxNames.forEach(el => {
      if (el.textContent.trim() === 'Germany') {
        el.textContent = 'Switzerland';
      }
    });
    countryBoxFlags.forEach(el => {
      if (el.src.includes('/de.svg')) {
        el.src = 'https://app.transtore.app/flags/ch.svg';
        el.alt = 'Switzerland';
      }
    });
  }, 500);

  if (window.innerWidth < 990) {
    const handler = document.querySelector(".responsive-mega-handler");
    const megaHandler = document.querySelector("a.shop--menu");
    const productLabelHandler = document.querySelector(
      ".product-menu-label-head"
    );
    const navbarMenu = document.querySelector(
      ".custom-mega-menu-widget .mega-menu-main-navbar"
    );
    const megaMenu = document.querySelector(
      ".custom-mega-menu-widget .custom-megemenu"
    );

    if (handler && navbarMenu) {
      handler.addEventListener("click", function () {
        navbarMenu.classList.toggle("navbar-show");
      });
    }

    if (megaHandler && megaMenu) {
      megaHandler.addEventListener("click", function (e) {
        e.preventDefault();
        megaMenu.classList.toggle("mega-show");
      });
    }

    document.addEventListener("click", function (e) {
      const target = e.target.closest(".product-menu-label-head");
      if (target) {
        const productMenuCol = target.closest(".product-menu-col");
        if (productMenuCol) {
          const menuList = productMenuCol.querySelector(".menu-list-ul");
          if (menuList) {
            menuList.classList.toggle("active");
          }
        }
      }
    });

    // Handle close button inside each mega menu
    document.querySelectorAll(".megamenu--close").forEach((closeBtn) => {
      closeBtn.addEventListener("click", function () {
        const megaMenu = this.closest(".custom-megemenu");
        if (megaMenu && megaMenu.classList.contains("mega-show")) {
          megaMenu.classList.remove("mega-show");
        }
      });
    });

    // Handle close button inside navbar menu
    document.querySelectorAll(".navbar--close").forEach((closeBtn) => {
      closeBtn.addEventListener("click", function () {
        const megaMenu = this.closest(".mega-menu-main-navbar");
        if (megaMenu && megaMenu.classList.contains("navbar-show")) {
          megaMenu.classList.remove("navbar-show");
        }
      });
    });
  }

  // Dektop Megamenu Hover
  if (window.innerWidth > 990) {
    const navItem = document.querySelector(".mega-menu-main-navbar ul li");
    const megaMenu2 = document.querySelector(".custom-megemenu");
    let hideTimeout;
    if (navItem && megaMenu2) {
      navItem.addEventListener("mouseenter", () => {
        clearTimeout(hideTimeout); // Cancel hiding if re-entered quickly
        megaMenu2.style.display = "block";
        megaMenu2.style.opacity = "1";
        megaMenu2.style.visibility = "visible";
      });
      navItem.addEventListener("mouseleave", () => {
        hideTimeout = setTimeout(() => {
          megaMenu2.style.display = "none";
          megaMenu2.style.opacity = "0";
          megaMenu2.style.visibility = "hidden";
        }, 300); // Delay before hiding
      });
      megaMenu2.addEventListener("mouseenter", () => {
        clearTimeout(hideTimeout); // Cancel hiding if user enters mega menu
      });
      megaMenu2.addEventListener("mouseleave", () => {
        hideTimeout = setTimeout(() => {
          megaMenu2.style.display = "none";
          megaMenu2.style.opacity = "0";
          megaMenu2.style.visibility = "hidden";
        }, 300);
      });
    }
  }
  // Nav Tabs - JS
  const tabs = document.querySelectorAll(".nav-tab");
  const panes = document.querySelectorAll(".tab-pane");

  tabs.forEach((tab) => {
    tab.addEventListener("click", function () {
      tabs.forEach((t) => t.classList.remove("active"));
      panes.forEach((p) => p.classList.remove("active"));

      this.classList.add("active");

      const tabId = this.getAttribute("data-tab");
      document.getElementById(tabId).classList.add("active");
    });
  });

  // // Testimonials Widget Open Modal
  // const bodyHasProduct = document.querySelector(".product-style-01");
  // if (bodyHasProduct) {
  //   const writeReviewLinks = document.querySelectorAll(".jdgm-write-rev-link");
  //   writeReviewLinks.forEach((link) => {
  //     link.addEventListener("click", function (e) {
  //       e.preventDefault();
  //       document.querySelector('.review-modal').classList.add('review-modal--show');
  //     });
  //   });
  // }
  // // Handle close review modal on close
  // document.querySelectorAll(".review--closeModal").forEach((closeBtn) => {
  //   closeBtn.addEventListener("click", function () {
  //     const reviewModal = this.closest(".review-modal");
  //     if (reviewModal && reviewModal.classList.contains("review-modal--show")) {
  //       reviewModal.classList.remove("review-modal--show");
  //     }
  //   });
  // });
});
/*
$(document).ready(function () {
  var boostInterval = setInterval(function () {

    var found = false;

    $('.boost-sd__product-info').each(function () {

      var $this = $(this);
      var $price = $this.find('.boost-sd__product-price');
      var $price_acc = $price.find('.boost-sd__format-currency');

      var priceText = $price_acc.text().trim();

      if (priceText === 'CHF 0') {

        found = true;

        $this.find('.boost-sd__product-price, .boost-sd__button').hide();

        // Prevent duplicate button
        if (!$this.parent().find('.collection-request-quote').length) {
          $this.parent().append(
            '<a href="/pages/contact/" class="collection-request-quote">Angebot anfordern</a>'
          );
        }
      }

    });

    // Stop interval once products are processed
    if (found) {
      clearInterval(boostInterval);
      console.log('Interval cleared');
    }

  }, 500);

});
*/

/*  working code which  hide the udplicate product and and replace button  if price is zero  and hide the add to  cart option 
(function () {

  // =============================================
  // GLOBAL state — pagination
  // =============================================
  let seenTitles = new Set();
  let debounceTimer = null;
  let lastPageUrl = location.href;


  function processBoostCard(card) {
 
    if (card.dataset.fixApplied === '1') return;

    const titleEl = card.querySelector('.boost-sd__product-title');
    if (!titleEl) return;

    const title = titleEl.textContent.trim().toLowerCase();

    // Duplicate — hide karo
    if (seenTitles.has(title)) {
      card.style.display = 'none';
      card.dataset.fixApplied = '1';
      return;
    }
    seenTitles.add(title);
    card.dataset.fixApplied = '1';

    // Price check — data-product JSON se (most reliable)
    let priceMin = null;
    try {
      const data = JSON.parse(card.getAttribute('data-product'));
      priceMin = parseFloat(data.priceMin);
    } catch (e) {}

    if (priceMin === 0) {
      const priceEl = card.querySelector('.boost-sd__product-price');
      if (priceEl) priceEl.style.display = 'none';

      // Saare boost buttons hide karo
      card.querySelectorAll('.boost-sd__button').forEach(function (btn) {
        btn.style.display = 'none';
      });

      const infoWrapper = card.querySelector('.boost-sd__product-info');
      if (infoWrapper && !infoWrapper.querySelector('.collection-request-quote')) {
        const link = document.createElement('a');
        link.href = '/pages/contact/';
        link.className = 'collection-request-quote';
        link.textContent = 'Angebot anfordern';
        infoWrapper.appendChild(link);
      }
    }
  }

  function processCustomCard(card) {
    if (card.dataset.fixApplied === '1') return;

    const titleEl = card.querySelector('.product-title');
    if (!titleEl) return;

    const title = titleEl.textContent.trim().toLowerCase();

    if (seenTitles.has(title)) {
      card.style.display = 'none';
      card.dataset.fixApplied = '1';
      return;
    }
    seenTitles.add(title);
    card.dataset.fixApplied = '1';

    const priceEl = card.querySelector('.product-price');
    if (!priceEl) return;

    
    const priceText = priceEl.textContent.replace(/[^0-9.,]/g, '').trim();
    const priceNum = parseFloat(priceText.replace(',', '.'));

    if (!isNaN(priceNum) && priceNum === 0) {
      priceEl.innerHTML = '<span style="font-weight:600;color:#333;">Angebot anfordern</span>';
      const btn = card.querySelector('.product-btn');
      if (btn) {
        btn.href = '/pages/contact/';
        btn.textContent = 'Angebot anfordern';
      }
    }
  }


  function applyFixes() {
    document.querySelectorAll('.boost-sd__product-item').forEach(processBoostCard);
    document.querySelectorAll('.product-grid-item').forEach(processCustomCard);
  }

  function checkPageChange() {
    const currentUrl = location.href;
    if (currentUrl !== lastPageUrl) {
      lastPageUrl = currentUrl;

      seenTitles = new Set();
      document.querySelectorAll('.boost-sd__product-item[data-fix-applied], .product-grid-item[data-fix-applied]').forEach(function (card) {
        delete card.dataset.fixApplied;
      });
    }
  }

  // =============================================
  // Debounce wrapper
  // =============================================
  function debouncedApply() {
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(function () {
      checkPageChange();
      applyFixes();
    }, 250);
  }

  // =============================================
  // DOM Ready 
  // =============================================
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', applyFixes);
  } else {
    applyFixes();
  }

  // =============================================
  // MutationObserver — AJAX changes 
  // =============================================
  const observer = new MutationObserver(function (mutations) {
    let shouldRun = false;
    for (let i = 0; i < mutations.length; i++) {
      const m = mutations[i];
      if (m.addedNodes.length > 0) {
        shouldRun = true;
        break;
      }
    }
    if (shouldRun) debouncedApply();
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });

  // =============================================
  // Boost SD Custom Events — pagination, filter
  // =============================================
  ['boost-sd:products-rendered', 'boost-sd:page-changed', 'boost-sd:filter-applied', 'boost-sd:sort-changed'].forEach(function (evtName) {
    document.addEventListener(evtName, debouncedApply);
  });


  setInterval(function () {
    if (location.href !== lastPageUrl) {
      debouncedApply();
    }
  }, 500);

})();
*/

(function () {

  let debounceTimer = null;

  // ===============================
  // BOOST CARD (Search & Filter)
  // ===============================
  function processBoostCard(card) {

    if (card.dataset.fixApplied === '1') return;

    let priceMin = null;

    try {
      const data = JSON.parse(card.getAttribute('data-product'));
      priceMin = parseFloat(data.priceMin);
    } catch (e) { }

    if (priceMin === 0) {

      // Hide price
      const priceEl = card.querySelector('.boost-sd__product-price');
      if (priceEl) priceEl.style.display = 'none';

      // Hide all Boost buttons (Add to cart etc.)
      card.querySelectorAll('.boost-sd__button').forEach(function (btn) {
        btn.style.display = 'none';
      });

      // Add Request Quote button
      const infoWrapper = card.querySelector('.boost-sd__product-info');
      if (infoWrapper && !infoWrapper.querySelector('.collection-request-quote')) {

        const link = document.createElement('a');
        link.href = '/pages/contact/';
        link.className = 'collection-request-quote';
        link.textContent = 'Angebot anfordern';

        infoWrapper.appendChild(link);
      }
    }

    card.dataset.fixApplied = '1';
  }

  // ===============================
  // CUSTOM PRODUCT GRID
  // ===============================
  function processCustomCard(card) {

    if (card.dataset.fixApplied === '1') return;

    const priceEl = card.querySelector('.product-price');
    if (!priceEl) return;

    const priceText = priceEl.textContent.replace(/[^0-9.,]/g, '').trim();
    const priceNum = parseFloat(priceText.replace(',', '.'));

    if (!isNaN(priceNum) && priceNum === 0) {

      // Replace price text
      priceEl.innerHTML = '<span style="font-weight:600;color:#333;">Angebot anfordern</span>';

      // Change button
      const btn = card.querySelector('.product-btn');
      if (btn) {
        btn.href = '/pages/contact/';
        btn.textContent = 'Angebot anfordern';
      }
    }

    card.dataset.fixApplied = '1';
  }

  // ===============================
  // Apply Fix
  // ===============================
  function applyFixes() {
    document.querySelectorAll('.boost-sd__product-item').forEach(processBoostCard);
    document.querySelectorAll('.product-grid-item').forEach(processCustomCard);
  }

  function debouncedApply() {
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(applyFixes, 250);
  }

  // DOM Ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', applyFixes);
  } else {
    applyFixes();
  }

  // Observe AJAX changes (Boost filters, pagination)
  const observer = new MutationObserver(function (mutations) {
    for (let i = 0; i < mutations.length; i++) {
      if (mutations[i].addedNodes.length > 0) {
        debouncedApply();
        break;
      }
    }
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });

})();


(function () {
  const message = 'Die Lieferkosten werden separat berechnet und per E-Mail mitgeteilt.';

  function addDeliveryMessage() {
    // Find the Boost side cart
    const cart = document.querySelector('#boost-sd__modal-cart');

    if (!cart) return;

    // Prevent duplicate messages
    if (cart.querySelector('.custom-delivery-cost-message')) return;

    // Find the Checkout button
    const checkoutButton = cart.querySelector('.boost-sd__btn-checkout');

    if (!checkoutButton) return;

    // Create the message
    const messageElement = document.createElement('div');
    messageElement.className = 'custom-delivery-cost-message';
    messageElement.textContent = message;

    // Add styling
    messageElement.style.cssText = `
      display: block !important;
      visibility: visible !important;
      opacity: 1 !important;
      padding: 12px 10px;
      margin: 10px 0;
      text-align: center;
      font-size: 14px;
      line-height: 1.5;
    `;

    // Insert message above Checkout button
    checkoutButton.parentNode.insertBefore(
      messageElement,
      checkoutButton
    );
  }

  // Run initially
  addDeliveryMessage();

  // Watch for Boost cart updates/re-rendering
  const observer = new MutationObserver(function () {
    addDeliveryMessage();
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
})();